import './styles.scss';

import { I18n, Translate } from '@utils/i18n';
import { Link } from 'react-router-dom';
import React from 'react';
import { debounce } from 'lodash';
import { ClipLoader } from 'react-spinners';
import { useAuth } from '_clean-code/api/hooks/useAuth';

const LoginV2 = () => {
  const { login, loginWithOkta } = useAuth();
  const emailInputRef = React.useRef<HTMLInputElement>(null);
  const passwordInputRef = React.useRef<HTMLInputElement>(null);

  const debouncedLogin = debounce((email: string, password: string) => {
    login.mutate({ email, password });
  }, 300);

  const debouncedOktaLogin = debounce(() => {
    loginWithOkta.mutate();
  }, 300);

  const handleLogin = (event: React.FormEvent) => {
    event.preventDefault();

    if (emailInputRef.current !== null && passwordInputRef.current !== null) {
      const email = emailInputRef.current.value.trim();
      const password = passwordInputRef.current.value;
      debouncedLogin(email, password);
    }
  };

  return (
    <div className="py-7 px-5">
      <form id="login-form" className="login-form-1" onSubmit={handleLogin}>
        <div>
          <label htmlFor="lg_username" className="input__label">
            <Translate value="email" />
            &nbsp;*
          </label>
          <div className="input-group py-1">
            <input
              type="text"
              className="form-control"
              id="lg_username"
              name="email"
              placeholder="company@pulsarml.com"
              required
              ref={emailInputRef}
            />
          </div>
        </div>

        <div className="mt-4">
          <label htmlFor="lg_password" className="input__label">
            <Translate value="password_label" />
            &nbsp;*
          </label>
          <div className="input-group py-1">
            <input
              type="password"
              className="form-control"
              id="lg_password"
              name="password"
              placeholder={I18n.t('password_label')}
              required
              ref={passwordInputRef}
            />
          </div>
        </div>

        <button type="submit" className="btn mt-4 submit-button px-4">
          {login.isPending ? (
            <ClipLoader size={20} loading color={'#fff'} />
          ) : (
            I18n.t('login_title')
          )}
        </button>

        <div className="text-center form-message mt-4">
          <Translate value="cant_access_your_account" />
          <br />
          <Link to="/forgot-password">
            <Translate value="forgot_password" />
          </Link>
        </div>
        <div className="content mt-3">
          <p className="or">
            <Translate value="or" />
          </p>
        </div>
        <button
          type="button"
          className="btn mt-2 submit-button px-4"
          onClick={debouncedOktaLogin}
        >
          {loginWithOkta.isPending ? (
            <ClipLoader
              size={20}
              loading={loginWithOkta.isPending}
              color={'#fff'}
            />
          ) : (
            I18n.t('login_with_okta')
          )}
        </button>
      </form>
    </div>
  );
};

export default LoginV2;
